const mutations = {


  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE (state, value) {
    state.isVerticalNavMenuActive = value
  },
  TOGGLE_REDUCE_BUTTON (state, val) {
    state.reduceButton = val
  },
  UPDATE_MAIN_LAYOUT_TYPE (state, val) {
    state.mainLayoutType = val
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN (state, val) {
    state.verticalNavMenuItemsMin = val
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH (state, width) {
    state.verticalNavMenuWidth = width
  },


  UPDATE_STARRED_PAGE (state, payload) {

    // find item index in search list state
    const index = state.navbarSearchAndPinList["pages"].data.findIndex((item) => item.url === payload.url)

    // update the main list
    state.navbarSearchAndPinList["pages"].data[index].is_bookmarked = payload.val

    // if val is true add it to starred else remove
    if (payload.val) {
      state.starredPages.push(state.navbarSearchAndPinList["pages"].data[index])
    } else {
      // find item index from starred pages
      const index = state.starredPages.findIndex((item) => item.url === payload.url)

      // remove item using index
      state.starredPages.splice(index, 1)
    }
  },

  // Navbar-Vertical

  ARRANGE_STARRED_PAGES_LIMITED (state, list) {
    const starredPagesMore = state.starredPages.slice(10)
    state.starredPages = list.concat(starredPagesMore)
  },
  ARRANGE_STARRED_PAGES_MORE (state, list) {
    let downToUp = false
    const lastItemInStarredLimited = state.starredPages[10]
    const starredPagesLimited = state.starredPages.slice(0, 10)
    state.starredPages = starredPagesLimited.concat(list)

    state.starredPages.slice(0, 10).map((i) => {
      if (list.indexOf(i) > -1) downToUp = true
    })

    if (!downToUp) {
      state.starredPages.splice(10, 0, lastItemInStarredLimited)
    }
  },


  // ////////////////////////////////////////////
  // UI
  // ////////////////////////////////////////////

  TOGGLE_CONTENT_OVERLAY (state, val) { state.bodyOverlay = val },
  UPDATE_PRIMARY_COLOR (state, val) { state.themePrimaryColor = val },
  UPDATE_THEME (state, val) { state.theme = val },
  UPDATE_WINDOW_WIDTH (state, width) { state.windowWidth = width },
  UPDATE_WINDOW_SCROLL_Y (state, val) { state.scrollY = val },


  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  // Updates user info in state and localstorage
  UPDATE_USER_INFO (state, payload) {

    // Get Data localStorage
    const userInfo = JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser

    for (const property of Object.keys(payload)) {

      if (payload[property] !== null) {
        // If some of user property is null - user default property defined in state.AppActiveUser
        state.AppActiveUser[property] = payload[property]

        // Update key in localStorage
        userInfo[property] = payload[property]
      }
    }
    // Store data in localStorage
    localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },
  UPDATE_USER_ORGANISATIONS (state, payload) {
    const userInfo = state.AppActiveUser
    const organisations = payload.organisations
    userInfo.organisations = organisations
    let org = organisations.find(a => a.id === userInfo.activeOrganisationId)
    if (!org) {
      org = organisations[0]
    }
    userInfo.activeOrganisationId = org ? org.id : 0
    if (userInfo.isSystemAdmin) {
      userInfo.userRole = "admin"
    }
    else if (org) {
      userInfo.userRole = org.role === "admin" ? "editor" : org.role
    } else {
      userInfo.userRole = "retailer"
    }

    localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },
  UPDATE_ACTIVE_ORGANISATION (state, payload) {
    const userInfo = state.AppActiveUser
    userInfo.activeOrganisationId = payload
    const org = userInfo.organisations.find(a => a.id === userInfo.activeOrganisationId)
    userInfo.activeOrganisationId = org ? org.id : 0
    if (userInfo.isSystemAdmin) {
      userInfo.userRole = "admin"
    }
    else {
      if (org) {
        userInfo.userRole = org.role === "admin" ? "editor" : org.role
      }
      else {
        userInfo.userRole = "user"
      }
    }
    localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },
  SET_IS_LOADING (state, payload) {
    //TODO IsLoading
  },
  UPDATE_USER_CAMPAIGNS (state, payload) {
    const userInfo = state.AppActiveUser
    userInfo.campaigns = payload.campaigns
    if (userInfo.campaigns.length === 0) {
      userInfo.activeCampaignId = 0
      userInfo.activeStrategyId = 0
    } else {
      const campaign = payload.campaigns.find(a => a.id === userInfo.activeCampaignId)
      if (!campaign) {
        userInfo.activeCampaignId = payload.campaigns[0].id        
      }
    }
    localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },
  UPDATE_ACTIVE_CAMPAIGN (state, payload) {
    const userInfo = state.AppActiveUser
    userInfo.activeCampaignId = payload
    localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },
  UPDATE_USER_STRATEGIES (state, payload) {
    const userInfo = state.AppActiveUser
    userInfo.strategies = payload.strategies
    if (userInfo.strategies.length === 0) {
      userInfo.activeStrategyId = 0
    } else {
      const strategy = payload.strategies.find(a => a.id === userInfo.activeStrategyId)
      if (!strategy) {
        userInfo.activeStrategyId = 0
      }
    }
    localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },
  UPDATE_ACTIVE_STRATEGY (state, payload) {
    const userInfo = state.AppActiveUser
    userInfo.activeStrategyId = payload
    localStorage.setItem("userInfo", JSON.stringify(userInfo))
  },
}

export default mutations

